import { Component, Input, OnInit, OnChanges, Output, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Observable }        from 'rxjs/Observable';
import { Subject }           from 'rxjs/Subject';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { SearchService } from '../shared/search.service';
import { UtilsService } from '../shared/utils.service';

@Component({
    selector: 'search-autocomplete',
    template: `
        <ul *ngIf="isOnFocus() && autocompleteContent" class="autocomplete" (mouseleave)="onAutocompleteLeave()">
            <li *ngFor="let e of autocompleteContent">
                <a (click)="onSelect(e.name)">{{e.name}}</a>
            </li>
        </ul>
    `
})
export class SearchAutocompleteComponent implements OnInit,OnChanges {// 

    private autocompleteEventEmitter = new Subject<string>();
    public autocompleteContent;
    private autocompleteTriggerThreshold = 2;

    @Input() form: FormGroup;
    @Input() formPath: string;
    @Input() onSelectCallBack: Function;
    @Input() target: string;
    @Input() input: any;
    @Input() esType: string;

    constructor (public el: ElementRef, private searchService: SearchService, private utils: UtilsService) {
    }

    onSelect(val) {
        this.input.element.value = val;
        // Update reactive form
        if(this.form && this.formPath)
            this.form.get(this.formPath).setValue(val);
        // Clear
        this.autocompleteContent = null;
    }

    ngOnInit() {
        this.autocompleteEventEmitter
            .debounceTime(300)
            //.distinctUntilChanged()
            .switchMap(input => {
                 return this.searchService.autocomplete('record', this.esType, input);
            }).subscribe(res => {
                this.autocompleteContent = res[this.esType];
            }, error => {
                console.log(error);
            });
    }

    ngOnChanges(changes?){
        if(this.isOnFocus()){
            if(this.input.element && this.input.element.value.length >= this.autocompleteTriggerThreshold)
                this.autocompleteEventEmitter.next(this.input.element.value);
            else 
                this.autocompleteContent = null;
        }
    }

    isOnFocus(): boolean{
        if(this.input.element && this.target==this.input.element.id)
            return true;
        return false;
    }

    onAutocompleteLeave(){
        // In the mean time, move may have come back over
        setTimeout(()=>{ 
            this.autocompleteContent = null 
        }, 1000)
    }

} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/search-autocomplete.component.ts